import React from "react";
import ClickAndSave from "../../components/ClickAndSave/ClickAndSave";

const ClickAndSavePage = () => {
  return <ClickAndSave />;
};

export default ClickAndSavePage;
